import React from 'react';

import RoleEdit from '@/modules/role/RoleSetup/RoleEdit';

const RoleSetupPage = () => {

  return (
    <RoleEdit />
    
  );
};
export default RoleSetupPage;
